export default {
  logo: "https://thq-mj-woolworths.s3.ap-southeast-2.amazonaws.com/assets/countdown/NON+LOGGED+IN+Banner.png",
  logo_small: "/asset/countdown/logo-small.png",
  logo_word: "https://thq-mj-woolworths.s3.ap-southeast-2.amazonaws.com/assets/countdown/New+Wwnz-logo.png",
  landing: {
    registration_exist: "/assets/countdown/graphics-alert.jpg",
    default: "/assets/thq/landing/index.jpg"
  },
}
